import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConnectedContentCredentials = lazy(() =>
  import("@scenes/ConnectedContentCredentials").then((module) => ({
    default: module.default.ConnectedContentCredentials,
  }))
);

export const connectedContentNRO: NavigationRoutingObject = {
  Component: ConnectedContentCredentials,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">, { featureOn }) =>
    featureOn("webhook_credential_management")
      ? t("credential-management-menu-option", "Credential Management")
      : t("connected-content-menu-option", "Connected Content"),
  pageNameForTracking: () => "Connected Content",
  getDeveloperNavigationAllowed: ({ hasPermission }) => hasPermission("appGroup", { permission: "manageAppGroup" }),
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [
        t("connected-content-menu-option", "Connected Content"),
        t("connected-content-alt-keyword-1", "Authentication Credentials"),
        t("connected-content-alt-keyword-2", "Webhook Credentials"),
      ],
    },
    {
      keywords: [t("credential-management-menu-option", "Credential Management")],
      description: t("previously-connected-content", 'Previously "Connected Content"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
